import { COLLECTIONS } from "constants/action-types";

export const mutateValidationLog = (key: string, newLog: nuorder.collection.validation_log.ValidationLog) => ({
    type: COLLECTIONS.COLLECTION.VALIDATION_LOG.MUTATE,
    payload: { key, newLog },
});

export const fetchValidationLogUsers = (collectionId: string) => ({
    type: COLLECTIONS.COLLECTION.VALIDATION_LOG.AUTHORS.FETCH.START,
    payload: { collectionId },
});

export const updateValidationItemAuthor = (label: string, name: string, email: string) => ({
    type: COLLECTIONS.COLLECTION.VALIDATION_LOG.AUTHORS.FETCH.COMPLETED,
    payload: { label, name, email },
});
